import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
const bonuses = [{
  num: '1',
  title: 'Master Excel: Il Correttore Automatico',
  price: '€67',
  desc: 'Fogli di calcolo intelligenti che correggono bilanci e verifiche al posto tuo. Inserisci i dati e in 30 secondi hai la valutazione pronta. Zero calcoli manuali.'
}, {
  num: '2',
  title: 'Banca delle Verifiche: 25 Test Pronti con Soluzioni',
  price: '€47',
  desc: "Verifiche sommative già pronte per ogni modulo dell'anno. Stampa, distribuisci e correggi con il soluzionario già incluso. Non costruirai mai più una verifica da zero."
}, {
  num: '3',
  title: 'Kit 35 Griglie di Valutazione Oggettive',
  price: '€47',
  desc: 'Griglie conformi MIM compatibili con ClasseViva, Argo e Axios. Valutazioni professionali e difendibili davanti a qualsiasi genitore o Dirigente.'
}, {
  num: '4',
  title: 'Le 33 Ore di Educazione Civica: 10 Lezioni PPT Pronte',
  price: '€37',
  desc: "Le ore obbligatorie già pianificate, documentate per il registro e collegate al programma di Economia Aziendale. Adempi all'obbligo di legge senza un minuto di preparazione extra."
}];
export function BonusSection() {
  return <section className="py-10 sm:py-12 px-4 relative overflow-hidden" data-id="element-35">
      <div className="absolute inset-0 bg-brand-orange/5 blur-[120px] rounded-full max-w-3xl mx-auto" data-id="element-36" />

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-37">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8 flex flex-col items-center" data-id="element-38">
          <div className="bg-brand-orange/20 p-4 rounded-full mb-4" data-id="element-39">
            <GiftIcon className="w-10 h-10 text-brand-orange" data-id="element-40" />
          </div>
          <p className="text-xs font-black uppercase tracking-widest text-brand-orange mb-3" data-id="element-41">
            Bonus inclusi
          </p>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-black text-brand-cream leading-tight" data-id="element-42">
            4 Bonus Strategici nel tuo{' '}
            <span className="bg-gradient-to-r from-brand-orange via-brand-amber to-brand-gold bg-clip-text text-transparent" data-id="element-43">
              Metodo
            </span>
            , senza costi extra
          </h2>
          <p className="text-base sm:text-lg text-gray-400 mt-3 max-w-2xl" data-id="element-44">
            Strumenti aggiuntivi del valore di €198 inclusi con l'acquisto.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 gap-4" data-id="element-45">
          {bonuses.map((bonus, i) => <motion.div key={i} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-gradient-to-br from-brand-card to-[#2a1810] border border-brand-orange/30 p-6 sm:p-8 rounded-2xl shadow-[0_0_20px_rgba(249,115,22,0.1)]" data-id="element-46">
              <div className="flex items-start justify-between gap-3 mb-4" data-id="element-47">
                <div className="flex items-start gap-3" data-id="element-48">
                  <span className="text-2xl shrink-0" data-id="element-49">🎁</span>
                  <h3 className="text-base sm:text-xl font-bold text-brand-gold leading-tight" data-id="element-50">
                    Bonus {bonus.num} — {bonus.title}
                  </h3>
                </div>
                <span className="text-brand-orange font-black text-base shrink-0" data-id="element-51">
                  {bonus.price}
                </span>
              </div>
              <p className="text-gray-300 font-medium leading-relaxed text-sm sm:text-base" data-id="element-52">
                {bonus.desc}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mt-6 text-center bg-brand-card border border-brand-gold/40 rounded-2xl py-4 px-5" data-id="element-53">
          <p className="text-brand-cream font-black text-sm sm:text-base" data-id="element-54">
            💎 VALORE TOTALE DEI 4 BONUS:{' '}
            <span className="text-brand-gold" data-id="element-55">€198</span> — INCLUSI GRATIS
          </p>
        </motion.div>
      </div>
    </section>;
}